import { assertDefined } from "../../sharedF/assertsF/assertDefinedF.mts"
import { LuxDuration } from "../../sharedF/timeF/Date1TimeF.mts"
import { minNoPlayers } from './constantsF.mts'

export const taskTimeLimitsMin = {
  InitialPrompt: 4,
  DrawDescription: 8,
  DescribeDrawing: 4,
}

export const gracePeriodSec = 15

export const getMyTurnRemainDur = ({myTaskName, gameActiveAt, now}) => {
  const totalMin = taskTimeLimitsMin[myTaskName]
  assertDefined(totalMin, {myTaskName})
  const maxTurnDur = LuxDuration.fromObject({minutes: totalMin})
  const elapsedDur = now.diff(gameActiveAt)
  const remainDur = maxTurnDur.minus(elapsedDur)
  return {maxTurnDur, elapsedDur, remainDur}
}

export const shouldNagPlayer = ({ activePlayerCount }) => activePlayerCount > minNoPlayers

export const getDeadlineMs = ({ myTaskName, gameActiveAt }) => {
  const taskLimitMin = taskTimeLimitsMin[myTaskName]
  if (!taskLimitMin) return null
  return gameActiveAt + (taskLimitMin * 60 * 1000) + (gracePeriodSec * 1000)
}